/**
 * @generated SignedSource<<6416571abb3c48710d2ab733be031682>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest } from 'relay-runtime';
export type RoundListAdditionalLessonInfoItemDisplayQuery$variables = {
  bookingId: string;
  duration?: number | null | undefined;
  groupSize?: number | null | undefined;
  lessonTypeId: string;
};
export type RoundListAdditionalLessonInfoItemDisplayQuery$data = {
  readonly node: {
    readonly bookingRounds?: {
      readonly edges: ReadonlyArray<{
        readonly node: {
          readonly roundRate: {
            readonly rate: {
              readonly __typename: "LessonRate";
              readonly totalDurationPrice: number | null | undefined;
            } | {
              // This will never be '%other', but we need some
              // value in case none of the concrete values match.
              readonly __typename: "%other";
            };
          } | null | undefined;
        } | null | undefined;
      } | null | undefined> | null | undefined;
    } | null | undefined;
    readonly startSlot?: {
      readonly __typename: "QueueSlot";
      readonly lessonCapacity: number;
    } | {
      readonly __typename: "TimeSlot";
      readonly lessonCapacity: number;
    } | {
      // This will never be '%other', but we need some
      // value in case none of the concrete values match.
      readonly __typename: "%other";
    } | null | undefined;
  } | null | undefined;
};
export type RoundListAdditionalLessonInfoItemDisplayQuery = {
  response: RoundListAdditionalLessonInfoItemDisplayQuery$data;
  variables: RoundListAdditionalLessonInfoItemDisplayQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "bookingId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "duration"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "groupSize"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "lessonTypeId"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "bookingId"
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "__typename",
  "storageKey": null
},
v3 = [
  {
    "alias": "lessonCapacity",
    "args": [
      {
        "kind": "Literal",
        "name": "bookingType",
        "value": "LESSON"
      },
      {
        "kind": "Variable",
        "name": "lessonTypeId",
        "variableName": "lessonTypeId"
      }
    ],
    "kind": "ScalarField",
    "name": "capacity",
    "storageKey": null
  }
],
v4 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "QueueSlot",
  "abstractKey": null
},
v5 = {
  "kind": "InlineFragment",
  "selections": (v3/*: any*/),
  "type": "TimeSlot",
  "abstractKey": null
},
v6 = {
  "kind": "InlineFragment",
  "selections": [
    {
      "alias": null,
      "args": [
        {
          "kind": "Variable",
          "name": "duration",
          "variableName": "duration"
        },
        {
          "kind": "Variable",
          "name": "playerCount",
          "variableName": "groupSize"
        }
      ],
      "kind": "ScalarField",
      "name": "totalDurationPrice",
      "storageKey": null
    }
  ],
  "type": "LessonRate",
  "abstractKey": null
},
v7 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "RoundListAdditionalLessonInfoItemDisplayQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "startSlot",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "bookingRounds",
                "args": null,
                "concreteType": "RoundConnection",
                "kind": "LinkedField",
                "name": "rounds",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoundEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RoundRate",
                            "kind": "LinkedField",
                            "name": "roundRate",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "rate",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v6/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          }
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "LessonBooking",
            "abstractKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "RootQueryType",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "RoundListAdditionalLessonInfoItemDisplayQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": null,
        "kind": "LinkedField",
        "name": "node",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "InlineFragment",
            "selections": [
              {
                "alias": null,
                "args": null,
                "concreteType": null,
                "kind": "LinkedField",
                "name": "startSlot",
                "plural": false,
                "selections": [
                  (v2/*: any*/),
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v7/*: any*/)
                ],
                "storageKey": null
              },
              {
                "alias": "bookingRounds",
                "args": null,
                "concreteType": "RoundConnection",
                "kind": "LinkedField",
                "name": "rounds",
                "plural": false,
                "selections": [
                  {
                    "alias": null,
                    "args": null,
                    "concreteType": "RoundEdge",
                    "kind": "LinkedField",
                    "name": "edges",
                    "plural": true,
                    "selections": [
                      {
                        "alias": null,
                        "args": null,
                        "concreteType": null,
                        "kind": "LinkedField",
                        "name": "node",
                        "plural": false,
                        "selections": [
                          (v2/*: any*/),
                          {
                            "alias": null,
                            "args": null,
                            "concreteType": "RoundRate",
                            "kind": "LinkedField",
                            "name": "roundRate",
                            "plural": false,
                            "selections": [
                              {
                                "alias": null,
                                "args": null,
                                "concreteType": null,
                                "kind": "LinkedField",
                                "name": "rate",
                                "plural": false,
                                "selections": [
                                  (v2/*: any*/),
                                  (v6/*: any*/),
                                  (v7/*: any*/)
                                ],
                                "storageKey": null
                              }
                            ],
                            "storageKey": null
                          },
                          (v7/*: any*/)
                        ],
                        "storageKey": null
                      }
                    ],
                    "storageKey": null
                  }
                ],
                "storageKey": null
              }
            ],
            "type": "LessonBooking",
            "abstractKey": null
          },
          (v7/*: any*/)
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "3367d0041ec1fac59ba179bdf8ca0f65",
    "id": null,
    "metadata": {},
    "name": "RoundListAdditionalLessonInfoItemDisplayQuery",
    "operationKind": "query",
    "text": "query RoundListAdditionalLessonInfoItemDisplayQuery(\n  $bookingId: ID!\n  $duration: Int\n  $groupSize: Int\n  $lessonTypeId: ID!\n) {\n  node(id: $bookingId) {\n    __typename\n    ... on LessonBooking {\n      startSlot {\n        __typename\n        ... on QueueSlot {\n          lessonCapacity: capacity(bookingType: LESSON, lessonTypeId: $lessonTypeId)\n        }\n        ... on TimeSlot {\n          lessonCapacity: capacity(bookingType: LESSON, lessonTypeId: $lessonTypeId)\n        }\n        id\n      }\n      bookingRounds: rounds {\n        edges {\n          node {\n            __typename\n            roundRate {\n              rate {\n                __typename\n                ... on LessonRate {\n                  totalDurationPrice(duration: $duration, playerCount: $groupSize)\n                }\n                id\n              }\n            }\n            id\n          }\n        }\n      }\n    }\n    id\n  }\n}\n"
  }
};
})();

(node as any).hash = "ab41f34e07c506a46cd41cab4b10f50c";

export default node;
